<template>
  <div id="form-reserva" class="row">
    <div class="col-md-12">
      <div class="titulo-seccion m-t-none">
        {{ $I18n.t('reserva') }}
      </div>
      <div>
        <div class="form-group">
          <thumbnail-header
            v-if="recurso"
            class="clearfix"
            :class="{ clickable: !edicion }"
            :imagen="recurso.foto_url"
            :titulo="recurso.nombre"
            :subtitulo="recurso.categoria.nombre"
            tamano="sm"
            @click="selectorRecurso()"
          />
          <div v-else class="btn btn-white block" @click="showModalRecurso = true">
            <i class="far fa-box-full fa-2x va-m m-r-sm"></i> Seleccione recurso
          </div>
          <ModalSimple
            v-model="showModalRecurso"
            tamano="lg"
            :altura-completa="true"
          >
            <selector-recursos
              :ids-recursos="recursoActualId ? [recursoActualId] : []"
              :multiple="false"
              :cerrar-al-seleccionar="true"
              @cancelado="showModalRecurso = false"
              @aceptado="recursoSeleccionado($event)"
            />
          </ModalSimple>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <input-checkbox-boolean
              v-model="todoElDia"
              :disabled="disabled"
            >
              {{ $I18n.t('Todo_el_dia') }}
            </input-checkbox-boolean>
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-sm-6">
          <input-fecha-hora
            v-model="fechaInicio"
            :disabled="disabled"
            :fixed-width="false"
            :timepicker="!todoElDia"
          />
        </div>
        <div class="col-sm-6">
          <input-fecha-hora
            v-model="fechaFin"
            :disabled="disabled"
            :fixed-width="false"
            :timepicker="!todoElDia"
          />
        </div>
      </div>
      <div v-if="puedeRepetir" class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <input-checkbox-boolean
              v-model="repetir"
              :disabled="disabled"
            >
              {{ $I18n.t('Repetir_semanalmente') }}
            </input-checkbox-boolean>
          </div>
        </div>
        <div class="col-sm-6">
          <input-fecha-hora
            v-if="repetir"
            v-model="fechaFinRepeticion"
            :disabled="disabled"
          />
        </div>
      </div>
      <div class="row form-group">
        <div :class="mostrarCantidad ? 'col-sm-8' : 'col-sm-12'">
          <label for="" class="control-label">{{ $I18n.t('Usuario') }}</label>
          <selector-usuario
            v-if="campoUsuarioEditable"
            v-model="usuarioActualId"
            :icon="true"
          />
          <p v-else-if="usuario" class="form-control input-fake nowrap">
            {{ fullname(usuario) }}
          </p>
        </div>
        <div class="col-sm-4">
          <selector-numerico
            v-if="mostrarCantidad"
            v-model.number="cantidad"
            :disabled="disabled"
            :min="1"
            :label="$I18n.t('Cantidad')"
            class="pull-right"
          />
        </div>
      </div>
      <div v-if="!disabled" class="form-group">
        <label for="" class="control-label">{{ $I18n.t('ubicacion') }}</label>
        <input
          v-model="ubicacion"
          type="text"
          class="form-control"
        />
      </div>
      <div v-if="!disabled" class="form-group">
        <label for="" class="control-label">{{ $I18n.t('Observaciones') }}</label>
        <textarea v-model="observaciones" class="form-control"></textarea>
      </div>
      <div class="form-actions">
        <boton-eliminar-evento
          v-if="reserva && !disabled"
          :evento-id="reserva.id"
          :uuid-repeticion="reserva.uuid_repeticion"
          class="pull-left"
          @confirmado="eliminar"
        />
        <button class="btn btn-default" @click.prevent="$emit('cancelado')">
          {{ labelCancelar }}
        </button>
        <boton-guardar
          v-if="!disabled"
          :submitting="guardando"
          :disabled="!puedeGuardar"
          @click="guardar"
        />
      </div>
    </div>
  </div>
</template>

<script>
import recursos from '@/api/recursos';
import usuarios from '@/api/usuarios';
import { subDays, addDays } from 'date-fns';
import ModalSimple from '@/components/ModalSimple.vue';
import { localISODateTimeString } from '../../../libs/dates';
import { showApiErrors } from '../../../libs/cifra/flash';
import Overlay from '../../../libs/cifra/overlay';
import toast from '../../../libs/cifra/toast';
import SelectorRecursos from './SelectorRecursos.vue';
import ThumbnailHeader from '../../../components/cifra/ThumbnailHeader.vue';
import BotonEliminarEvento from '../../../components/cifra/BotonEliminarEvento.vue';

export default {
  components: {
    SelectorRecursos, ThumbnailHeader, BotonEliminarEvento, ModalSimple,
  },
  props: {
    disabled: { type: Boolean, default: false },
    recursoId: { type: Number, default: null },
    reservaId: { type: Number, default: null },
    usuarioId: { type: Number, default: null },
    puedeCambiarUsuario: { type: Boolean, default: true },
  },
  data() {
    return {
      fechaInicio: null,
      fechaFin: null,
      fechaFinRepeticion: null,
      todoElDia: false,
      repetir: false,
      usuarioActualId: null,
      cantidad: 1,
      ubicacion: '',
      observaciones: '',
      guardando: false,
      recursoActualId: this.recursoId,
      reserva: null,
      recurso: null,
      usuario: null,
      showModalRecurso: false,
    };
  },
  computed: {
    puedeGuardar() {
      return this.recursoActualId && this.usuarioActualId
        && this.fechaInicio && this.fechaFin && this.cantidad;
    },
    puedeRepetir() {
      return !this.edicion;
    },
    mostrarCantidad() {
      if (!this.recurso) {
        return true;
      }
      // Para los aulas no se selecciona la cantidad
      return this.recurso.tipo !== 'espacio';
    },
    edicion() {
      return !!this.reservaId;
    },
    labelCancelar() {
      return this.$I18n.t(this.disabled ? 'Cerrar' : 'Cancelar');
    },
    campoUsuarioEditable() {
      return this.puedeCambiarUsuario && !this.edicion && !this.disabled;
    },
  },
  watch: {
    recursoActualId() {
      this._cargarRecurso();
    },
  },
  mounted() {
    if (this.reservaId) {
      this._cargarReserva();
    } else {
      if (this.recursoActualId) {
        this._cargarRecurso();
      }
      if (this.usuarioId) {
        this._cargarUsuario();
      }
    }
  },
  methods: {
    fullname: usuarios.fullname,
    fechasSeleccionadas(info) {
      this.fechaInicio = localISODateTimeString(info.start);
      this.todoElDia = info.allDay;
      // Se da el caso de que cuando seleccionas dias completos en fullcalendar, nos
      // devuelve del 2021-01-20 00:00 al 2021-01-22 00:00 cuando realmente hemos seleccionado
      // los días 20 y 21. Fullcallendar funciona así, el último día es excluyente pero nosotros
      // al usuario en el formulario le vamos a poner el último día válido
      if (this.todoElDia) {
        this.fechaFin = localISODateTimeString(subDays(info.end, 1));
      } else {
        this.fechaFin = localISODateTimeString(info.end);
      }
    },
    recursoSeleccionado(recurs) {
      const [recurso] = recurs;
      this.recurso = recurso;
      this.recursoActualId = this.recurso ? this.recurso.id : null;
      this.showModalRecurso = false;
    },
    selectorRecurso() {
      // No es editable
      if (this.edicion) {
        return;
      }
      this.showModalRecurso = true;
    },
    guardar() {
      if (this.disabled) {
        return;
      }

      let { fechaFin } = this;
      this.guardando = true;
      const overlay = new Overlay(this.$el);
      overlay.show();

      if (this.todoElDia) {
        // Ponemos un día más del seleccionado, ver explicación arriba
        fechaFin = localISODateTimeString(addDays(new Date(this.fechaFin), 1));
      }
      recursos.reservas.guardar({
        reserva: {
          id: this.reservaId,
          recurso_id: this.recursoActualId,
          fecha_inicio: this.fechaInicio,
          // Ponemos un día más del seleccionado, ver explicación arriba
          fecha_fin: fechaFin,
          todo_el_dia: this.todoElDia,
          usuario_id: this.usuarioActualId,
          cantidad: this.cantidad,
          ubicacion: this.ubicacion,
          observaciones: this.observaciones,
          tipo_repeticion: this.repetir ? 'semanal' : null,
          fecha_fin_repeticion: this.fechaFinRepeticion,
        },
      }).then((result) => {
        this.guardando = false;
        overlay.hide();
        toast.success(this.$I18n.t('reserva_correcta'));
        this.reset();
        this.$emit('guardado', result);
      }).catch((result) => {
        this.guardando = false;
        overlay.hide();
        showApiErrors(result);
      });
    },
    eliminar(confirmData) {
      this.guardando = true;
      const overlay = new Overlay(this.$el);
      overlay.show();
      recursos.reservas.eliminar(this.reserva.id, confirmData.tipoBorrado).then((result) => {
        this.guardando = false;
        overlay.hide();
        toast.success(this.$I18n.t('registro_eliminado_correctamente'));
        this.reset();
        this.$emit('eliminado', result);
      }).catch((result) => {
        this.guardando = false;
        overlay.hide();
        showApiErrors(result);
      });
    },
    reset() {
      this.fechaInicio = null;
      this.fechaFin = null;
      this.todoElDia = false;
      this.usuarioActualId = null;
      this.cantidad = 1;
      this.ubicacion = '';
      this.observaciones = '';
    },
    _cargarReserva() {
      recursos.reservas.get(this.reservaId).then((result) => {
        const { data } = result;
        this.fechaInicio = localISODateTimeString(new Date(data.fecha_inicio));
        this.fechaFin = localISODateTimeString(new Date(data.fecha_fin));
        this.todoElDia = data.todo_el_dia;
        this.recursoActualId = data.recurso.id;
        this.cantidad = data.cantidad;
        this.usuarioActualId = data.usuario.id;
        this.ubicacion = data.ubicacion;
        this.observaciones = data.observaciones;
        this.reserva = data;
        this.recurso = data.recurso;
        this.usuario = this.reserva.usuario;
      });
    },
    _cargarRecurso() {
      if (!this.recursoActualId) {
        this.recurso = null;
      } else {
        const recurso = this.recurso || {};
        // Si es el mismo id es que ya está cargado
        if (recurso.id !== this.recursoActualId) {
          recursos.recursos.get(this.recursoActualId).then((result) => {
            const { data } = result;
            this.recurso = data;
          });
        }
      }
    },
    _cargarUsuario() {
      usuarios.show(this.usuarioId).then((result) => {
        this.usuario = result.data;
        this.usuarioActualId = this.usuario.id;
      });
    },
  },
};
</script>
